// src/components/StatusBadge.js
import React from 'react';

export default function StatusBadge({ status, t, size = 'normal' }) {
  const config = {
    pending:  { bg: 'rgba(245,158,11,0.15)', color: '#FBBF24', icon: '⏳', label: t('coa.pending.statusPending') },
    approved: { bg: 'rgba(52,211,153,0.15)', color: '#34D399', icon: '✓',  label: t('coa.pending.statusApproved') },
    rejected: { bg: 'rgba(239,68,68,0.15)',  color: '#F87171', icon: '✕', label: t('coa.pending.statusRejected') },
  };
  const c = config[status] || config.pending;
  const pad = size === 'small' ? '3px 9px' : '5px 12px';
  const fontSize = size === 'small' ? 11 : 12;

  return (
    <span style={{
      background: c.bg, color: c.color, padding: pad, borderRadius: 20,
      fontSize, fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: 4,
      whiteSpace: 'nowrap',
    }}>
      {c.icon} {c.label}
    </span>
  );
}
